import React, { useContext } from "react";
import NotAccess from "../../components/common/userNotAccess/index";
import { StoreContext } from "../../store/Provider";

function RestrictAdmin(props) {
  const context = useContext(StoreContext);
  if (context.omsUserData?.UserRoles.includes("Admin")) return props.children;
  return <NotAccess />;
}

export default RestrictAdmin;
